import type { InventoryResource } from '@repo/api-gw-sdk';

import { fileSizeFormatter } from '@/utils/fileSizeFormatter';

import { SidePanelPropsTable } from '../../../sidePanelPropsTable';

export const FSxSection = ({ resource }: { resource: InventoryResource }) => {
  const fsxProps = resource.resourceProperties?.awsFsx;

  if (!fsxProps) {
    return null;
  }

  return (
    <SidePanelPropsTable withDividers columnSpace='medium'>
      <tbody>
        <tr>
          <td className='props-col'>File System ID</td>
          <td className='break-all'>{fsxProps.fileSystemId}</td>
        </tr>
        {fsxProps.name && (
          <tr>
            <td className='props-col'>Name</td>
            <td>{fsxProps.name}</td>
          </tr>
        )}
        {fsxProps.fileSystemType && (
          <tr>
            <td className='props-col'>File System Type</td>
            <td>{fsxProps.fileSystemType}</td>
          </tr>
        )}
        {fsxProps.storageSize !== undefined && (
          <tr>
            <td className='props-col'>Storage Capacity</td>
            <td>{fileSizeFormatter(fsxProps.storageSize)}</td>
          </tr>
        )}
        {fsxProps.storageType && (
          <tr>
            <td className='props-col'>Storage Type</td>
            <td>{fsxProps.storageType}</td>
          </tr>
        )}
        {fsxProps.lifecycleStatus && (
          <tr>
            <td className='props-col'>Lifecycle Status</td>
            <td>{fsxProps.lifecycleStatus}</td>
          </tr>
        )}
        {fsxProps.vpcId && (
          <tr>
            <td className='props-col'>VPC ID</td>
            <td>{fsxProps.vpcId}</td>
          </tr>
        )}
        {fsxProps.subnetIds && fsxProps.subnetIds.length > 0 && (
          <tr>
            <td className='props-col'>Subnet IDs</td>
            <td>{fsxProps.subnetIds.join(', ')}</td>
          </tr>
        )}
        {fsxProps.dnsName && (
          <tr>
            <td className='props-col'>DNS Name</td>
            <td className='break-all'>{fsxProps.dnsName}</td>
          </tr>
        )}
        {fsxProps.kmsKeyId && (
          <tr>
            <td className='props-col'>KMS Key ID</td>
            <td className='break-all'>{fsxProps.kmsKeyId}</td>
          </tr>
        )}
        {fsxProps.ownerId && (
          <tr>
            <td className='props-col'>Owner ID</td>
            <td>{fsxProps.ownerId}</td>
          </tr>
        )}
      </tbody>
    </SidePanelPropsTable>
  );
};
